module.exports = __webpack_public_path__ + "static/media/1018955.bb017ee4.jpg";